<template>
  <div>
    <form class="profile-form">
      <h3 style="margin-bottom: 0;">Edit Personal Information</h3>
      <hr>
      <label style="margin-top: 0;">Profile Picture</label>
      <input type="file" class="form-control-file" id="profile_pic" ref="profile_pic" v-on:change="handleFileUpload()"/>
      <!-- <div class="">
        <label>Summary</label>
        <textarea class="form-control" rows="3" v-model="summary" placeholder="Please describe yourself briefly, who you are, what your flying preferences and experiences are."></textarea>
      </div> -->
      <!-- <div class="">
        <div class="row">
          <div class="col-lg-6" :class="{ invalid: $v.firstName.$error }">
            <label for="fullName">First Name*</label>
            <input type="text" class="form-control" id="firstName" placeholder="" v-model="firstName">
            <small v-if="$v.firstName.$invalid && step1saveClicked">First name is required.</small>
            <small v-if="$v.firstName.$error">First name is required.</small>
          </div>
          <div class="col-lg-6" :class="{ invalid: $v.lastName.$error }">
            <label for="fullName">Last Name*</label>
            <input type="text" class="form-control" id="lastName" placeholder="" v-model="lastName">
            <small v-if="$v.lastName.$error">Last name is required.</small>
          </div>
        </div>
      </div> -->
      <div class="row">
        <!-- <div class="col-lg-6 form-group" :class="{ invalid: $v.phone.$error }"> -->
        <div class="col-lg-6 form-group">
          <label>First Name*</label>
          <input type="text" class="form-control" id="firstName" v-model="firstName">
          <small v-if="$v.firstName.$invalid && step1saveClicked">First name is required.</small>
          <small v-if="$v.firstName.$error">First name is required.</small>

          <label>Last Name*</label>
          <input type="text" class="form-control" id="lastName" v-model="lastName">
          <small v-if="$v.lastName.$error">Last name is required.</small>

          <label for="phone">Mobile Phone Number</label>
          <input type="text" class="form-control" id="phone" v-model="phone">
          <!-- <small v-if="$v.phone.$error">Phone number is required.</small> -->
          <label for="email">Email</label>
          <input type="text" class="form-control" id="email" v-model="email">
          <!-- <label for="linkedin">LinkedIn Profile URL</label> -->
          <!-- <input type="text" class="form-control" id="linkedin" placeholder="Please include https://www." v-model="linkedin"> -->
          <!-- <label>Facebook</label>
          <input type="text" class="form-control" placeholder="" v-model="facebook">
          <label>Instagram</label>
          <input type="text" class="form-control" placeholder="" v-model="instagram"> -->
        </div>

        <!-- <div class="col-lg-6 form-group" :class="{ invalid: $v.address1.$error || $v.city.$error || $v.country.$error || $v.postalCode.$error }"> -->
        <div class="col-lg-6 form-group">
          <label for="address">Location</label>
          <input type="text" class="form-control" id="address" placeholder="Address Line 1" v-model="address1">
          <!-- <small v-if="$v.address1.$error">Address is required.</small> -->
          <input type="text" class="form-control mt-2" placeholder="Address Line 2" v-model="address2">
          <input type="text" class="form-control mt-2" placeholder="City" v-model="city">
          <!-- <small v-if="$v.city.$error">City is required.</small> -->
          <input type="text" class="form-control mt-2" placeholder="Province/State" v-model="provinceState">
          <!-- <input type="text" class="form-control mt-2" placeholder="Country" v-model="country"> -->
          <multiselect style="font-family: 'articulatcf-regular';" class="mt-2" v-model="country" :options="countriesOptions" :multiple="false" :searchable="true" :close-on-select="true" :show-labels="false" placeholder="Country"></multiselect>
          <!-- <small v-if="$v.country.$error">Country is required.</small> -->
          <input type="text" class="form-control mt-2" placeholder="Postal/ZipCode" v-model="postalCode">
          <!-- <small v-if="$v.postalCode.$error">Postal/ZipCode is required.</small> -->
          <!-- <small v-if="$v.address2.$invalid && step1saveClicked">Este campo es obligatorio.</small> -->
        </div>
      </div>

      <hr>
      <!-- <h5 class="mt-4">Families will see your answers to these questions, give them some thought!</h5>
      <div>
        <label>In three words, how would your best friend describe your personality?</label>
        <textarea class="form-control" v-model="personality" rows="3"></textarea>
        <label>Do you have any hidden talents or hobbies?</label>
        <textarea class="form-control" v-model="talents" rows="3"></textarea>
        <label>What is your favorite thing to do on the weekends?</label>
        <textarea class="form-control" v-model="weekends" rows="3"></textarea>
        <label>What was your favorite subject in school?</label>
        <textarea class="form-control" v-model="subject" rows="3"></textarea>
      </div> -->

      <!-- <hr> -->
      <!-- <label>Describe the Qualities That Make You A Great Nanny*</label>
      <textarea rows="4" class="form-control" v-model="overview"></textarea>
      <label>What Kinds of Hobbies/Activities Do You Do In Your Free Time?*</label>
      <textarea rows="4" class="form-control" v-model="textField1"></textarea>
      <label>Please Describe What Type of Caregiver You See Yourself As?</label>
      <input type="text" class="form-control" placeholder="Example: lenient, structured, direct, soft, etc." v-model="selector1"> -->

      <hr>
      <!-- <button class="btn btn-success btn-lg mt-3" style="display: block;" @click.prevent="saveStep1">Save</button> -->
      <button class="mylisting-button dark-button" style="display: block; margin-left: auto;" @click.prevent="saveStep1">Save</button>

      <!-- <small v-if="$v.firstName.$error || $v.lastName.$error || $v.address1.$error || $v.city.$error || $v.country.$error || $v.postalCode.$error">There is an error with your submission.</small> -->
      <small v-if="$v.firstName.$error || $v.lastName.$error">There is an error with your submission.</small>
      <!-- {{ $v }} -->
      <!-- {{ userProfile }} -->
    </form>
  </div>
</template>

<script>
  import axios from 'axios';
  import { required, numeric } from 'vuelidate/lib/validators'; // Validators pre built into vuelidate - lecture 373
  // import ProfileView from './profile/ProfileView'

  // https://www.npmjs.com/package/vue-loading-overlay
  import Vue from 'vue';
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  // Init plugin
  Vue.use(Loading);

  export default {
    props: ['user'],
    data () {
      return {
        editing: false,

        // user: {},
        // users: [],
        currentStep: 1,

        summary: '',
        profilePic: '',
        name: '',
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        city: '',
        provinceState: '',
        // cities: ['Bogotá', 'Medellin', 'Cali', 'Barranquilla', 'Cartagena', 'Cúcuta', 'Soledad', 'Ibagué', 'Soacha', 'Bucaramanga'],
        country: '',
        address1: '',
        address2: '',
        postalCode: '',
        linkedin: '',

        organizationTypes: [],
        organizationTypesOptions: [],
        focusAreas: [],
        focusAreasOptions: [],

        // organizationStatures: [],
        // organizationStaturesOptions: [],
        sizes: [],
        sizesOptions: [],
        countries: [],
        countriesOptions: [],
        salaryRange: '',
        salaryRangeOptions: [],
        jobTypes: [],
        jobTypesOptions: [],

        pep: null,
        experiences: [],
        availability: [],
        title: '',
        reference: '',
        step1saveClicked: false,
        step2saveClicked: false,
        // --
        randomRenderer: [],

        // selector1: '',
        // selector1Options: [],
        // selector2: '',
        // selector2Options: [],
        // selector3: '',
        // selector3Options: [],

        // skills: [],
        // skillsOptions: [],
        // skills2: [],
        // skills2Options: [],
        // skills3: [],
        // skills3Options: [],

        // preferences: [],
        // preferencesOptions: [],

        title: '',
        titleOptions: [],

        facebook: '',
        instagram: '',

        overview: '',
        textField1: '',
        selector1: '',

        personality: '',
        talents: '',
        weekends: '',
        subject: '',
      }
    },
    components: {
      // appProfileView: ProfileView,
    },
    validations: { // Lecture 373
      // name: {
      //   required,
      // },
      firstName: {
        required,
      },
      lastName: {
        required,
      },
      // phone: {
      //   required,
      // },
      city: {
        required,
      },
      country: {
        required,
      },
      address1: {
        required,
      },
      postalCode: {
        required,
      }
    },
    computed: {
      auth () { // Lecture 363
        return this.$store.getters.isAuthenticated
      }
    },
    created () {
      // Scroll the window up
      window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route

      // this.getUser()

      this.sizesOptions = this.$store.getters.organizationSizes
      this.organizationTypesOptions = this.$store.getters.organizationTypes
      this.focusAreasOptions = this.$store.getters.focusAreas
      this.countriesOptions = this.$store.getters.countries
      this.skillsOptions = this.$store.getters.skills
      this.salaryRangeOptions = this.$store.getters.salaryRanges
      this.jobTypesOptions = this.$store.getters.jobTypes

      this.selector1Options = this.$store.getters.selector1Options
      this.selector2Options = this.$store.getters.selector2Options
      this.selector3Options = this.$store.getters.selector3Options

      this.skillsOptions = this.$store.getters.skills
      this.skills2Options = this.$store.getters.skills2
      this.skills3Options = this.$store.getters.skills3

      this.preferencesOptions = this.$store.getters.preferences

      this.titleOptions = this.$store.getters.titles

      // ----------------

      this.summary = this.user.overview
      // this.name = this.user.name
      this.firstName = this.user.first_name
      this.lastName = this.user.last_name
      this.phone = this.user.phone
      this.email = this.user.email
      this.city = this.user.city
      this.provinceState = this.user.provincestate
      this.country = this.user.country
      this.postalCode = this.user.postal_code
      this.address1 = this.user.address1
      this.address2 = this.user.address2
      this.linkedin = this.user.linkedin

      // this.facebook = this.user.facebook
      this.facebook = this.user.text12
      // this.instagram = this.user.instagram
      this.instagram = this.user.text13
      this.overview = this.user.overview
      this.textField1 = this.user.text_field1
      // this.textField2 = this.user.text2
      this.selector1 = this.user.selector1

      this.personality = this.user.text7
      this.talents = this.user.text8
      this.weekends = this.user.text9
      this.subject = this.user.text10
    },
    methods: {
      // getUser() {
      //   console.log(this.$store.getters.userID)
      //   // axios.get('/api/people/?id='.concat(this.$store.getters.userID))
      //   axios.get('/api/people/?id='.concat(this.user.id))
      //     .then(res => {
      //       // console.log(res)
      //       this.user = res.data[0]

      //       this.summary = this.user.overview
      //       // this.name = this.user.name
      //       this.firstName = this.user.first_name
      //       this.lastName = this.user.last_name
      //       this.phone = this.user.phone
      //       this.email = this.user.email
      //       this.city = this.user.city
      //       this.provinceState = this.user.provincestate
      //       this.country = this.user.country
      //       this.postalCode = this.user.postal_code
      //       this.address1 = this.user.address1
      //       this.address2 = this.user.address2
      //       this.linkedin = this.user.linkedin

      //       // this.focusAreas = this.user.sectors
      //       // this.jobTypes = this.user.job_types
      //       // this.organizationTypes = this.user.preferences3
      //       // this.countries = this.user.preferences2
      //       // this.sizes = this.user.preferences

      //       // this.salaryRange = this.user.salary_range
      //       // this.selector1 = this.user.selector1
      //       // this.selector2 = this.user.selector2
      //       // this.selector3 = this.user.selector3

      //       // this.skills = this.user.skills
      //       // this.skills2 = this.user.skills2
      //       // this.skills3 = this.user.skills3

      //       // this.preferences = this.user.preferences

      //       // this.title = this.user.title

      //       // this.facebook = this.user.facebook
      //       this.facebook = this.user.text12
      //       // this.instagram = this.user.instagram
      //       this.instagram = this.user.text13
      //       this.overview = this.user.overview
      //       this.textField1 = this.user.text_field1
      //       // this.textField2 = this.user.text2
      //       this.selector1 = this.user.selector1

      //       this.personality = this.user.text7
      //       this.talents = this.user.text8
      //       this.weekends = this.user.text9
      //       this.subject = this.user.text10
      //     })
      //     .catch(error => console.log(error))
      // },
      // https://serversideup.net/uploading-files-vuejs-axios/
      handleFileUpload() {
        this.profilePic = this.$refs.profile_pic.files[0];
      },
      saveStep1() {
        console.log('Saving Step 1')
        // $v.name.$touch();
        this.$v.$touch()
        // this.step1saveClicked = true
        // console.log(this.$store.getters.userAPIURL)
        // axios.patch(this.$store.getters.userAPIURL, {name: this.name})
        //   .then(res => console.log(res))
        //   .catch(error => console.log(error))

        // Only write to the database if all the fields have been filled
        // pep needs to be filled and be a number - https://stackoverflow.com/questions/175739/built-in-way-in-javascript-to-check-if-a-string-is-a-valid-number
        // if (this.name && this.city && this.country && this.address1 && this.pep && !isNaN(this.pep)) {
        // if (!this.$v.firstName.$error && !this.$v.lastName.$error && !this.$v.address1.$error && !this.$v.city.$error && !this.$v.country.$error && !this.$v.postalCode.$error) {
        if (!this.$v.firstName.$error && !this.$v.lastName.$error) {

          // console.log(this.user.status)
          // let new_status = this.user.status
          // if (this.user.status == '' || this.user.status == 'New') { // We only want to update the status if the user is at an earlier status
          //   new_status = 'Personal Information'
          // }

          axios.patch('/api/people/'.concat(this.user.id.toString()).concat('/'),
            {
              // name: this.name,
              overview: this.summary,
              first_name: this.firstName,
              last_name: this.lastName,
              phone: this.phone,
              email: this.email,
              city: this.city,
              provincestate: this.provinceState,
              country: this.country,
              address1: this.address1,
              address2: this.address2,
              postal_code: this.postalCode,
              // linkedin: this.linkedin,
              // facebook: this.facebook,
              // instagram: this.instagram,

              // text12: this.facebook,
              // text13: this.instagram,
              // overview: this.overview,
              // text_field1: this.textField1,
              // selector1: this.selector1,

              text7: this.personality,
              text8: this.talents,
              text9: this.weekends,
              text10: this.subject,
            }
          )
            .then(res => {
              console.log(res)

              let formData = new FormData();
              if (this.profilePic) {
                formData.append('profile_pic', this.profilePic);
              }

              axios.patch( '/api/people/'.concat(this.user.id.toString()).concat('/'),
                formData,
                {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                }
              )
                .then(res => {
                  // Scroll the window back up after saving the step
                  window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route

                  // this.getUser()
                  // this.editing = false

                  this.$emit('basicInfoSaved') // Lecture 112

                  // https://www.npmjs.com/package/vue-loading-overlay
                  let loader = this.$loading.show({
                    // Optional parameters
                    container: this.fullPage ? null : this.$refs.formContainer,
                    // container: this.$refs.formContainer,
                    // canCancel: true,
                    canCancel: false,
                    // onCancel: this.onCancel,
                  });
                  // simulate AJAX
                  setTimeout(() => {
                    loader.hide()
                  },2000)
                })
                .catch(error => {
                  console.log(error)
                })

            })
            .catch(error => console.log(error))
        }
      },
    },
  }
</script>

<style>

  /* PROFILE FORM TOP STEPS */
  .profile-step {
    border-bottom: 3px solid var(--thrivehiregrey);
  }
  .profile-step:hover {
    cursor: pointer;
  }
  .profile-step h4 {
    color: var(--thrivehiregrey);
  }
  .profile-step small {
    font-weight: 600;
    text-transform: uppercase;
    color: var(--thrivehiregrey);
  }
  .active-step {
    border-bottom: 3px solid var(--coredarkcolor);
  }
  .active-step h4 {
    color: var(--coredarkcolor);
  }
  .inactive-step {
    border-bottom: 3px solid var(--thrivehiregrey);
  }
  .inactive-step h4 {
    color: var(--thrivehiregrey);
  }
  .inactive-step small {
    font-weight: 600;
    text-transform: uppercase;
    color: var(--thrivehiregrey);
  }
  .active-step small {
    font-weight: 600;
    text-transform: uppercase;
    color: gray;
  }
  /* ------ */

  /* Lecture 299 */
  .slide-enter-active {
    animation: slide-in 300ms ease-out forwards;
  }

  .slide-leave-active {
    animation: slide-out 300ms ease-out forwards;
  }

  @keyframes slide-in {
    from {
      transform: translateY(-30px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @keyframes slide-out {
    from {
      transform: translateY(0px);
      opacity: 1;
    }
    to {
      transform: translateY(-30px);
      opacity: 0;
    }
  }

  /* Classes that get attached to form fields that fail vuelidation */
  .invalid label {
    color: red;
  }
  .invalid small {
    color: red;
  }

</style>



// WEBPACK FOOTER //
// src/components/candidates/profile/BasicInfoForm.vue